import { render, staticRenderFns } from "./TaskLogsList.vue?vue&type=template&id=279a54e4&"
import script from "./TaskLogsList.vue?vue&type=script&lang=js&"
export * from "./TaskLogsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports